import module from '../module';
import moment from 'moment';
import Constants from '../../../utils/CommonConstants';
import scopeUtils from '../../../utils/scope';
import {communicationService} from "../../../services/communicationService";
import {commandKeys} from "../../../shared/commandKeys";

export class OrderDetailsDirective {
    static $inject = [ '$scope', 'CartService', '$state', 'OrderSetupService', 'Message', '$rootScope', 'ConfigurationService', 'cartonomyConfig', '$interval', '$translate'];

    constructor(scope, cartService, stateService, orderSetupService, messageService, rootScope, configurationService, cartonomyConfig, $interval, $translate) {

        this._scope = scope;
        this._orderSetupService = orderSetupService;
        this._cartService = cartService;
        this._stateService = stateService;
        this._messageService = messageService;
        this._savedCart = {};
        this._scope.sections = [];
        this._rootScope = rootScope;
        this._configurationService = configurationService;
        this._scope.configuration = {
            readOnly: true,
            doNotAutoProcess: false,
            notificationsForParticipants: false,
            singlePay: false
        };
        this._cartonomyConfig = cartonomyConfig;
        this.$interval = $interval;
        this.$translate = $translate;

        this._scope.editSection = id => this._editSection(id);
        this._scope.updateCartName = () => this._updateCartName();
        this._scope.cancelCartNameChange = () => this._cancelCartNameChange();
        this._scope.saveCartName = () => this._saveCartName();
        this._scope.showUpdateCartName = false;
        this._scope.cartModel = {
            customCartNames: '0',
            cartNameValue: '',
            cartNameOldValue: ''
        }
        this._scope.$on(Constants.RootEvents.INVITATION_ACCEPTED, async () => await this._initialize());
    }

    async $onInit() {
        await this._initialize();
    }

    $onDestroy() {
        if (angular.isDefined(this.deadlineInterval)) {
            this.$interval.cancel(this.deadlineInterval);
            stop = undefined;
        }
    }

    async _initialize() {

        await this._reloadConfiguration();

        await this._loadCustomCartName();

        this._scope.$watch('configuration.doNotAutoProcess', (newValue, oldValue) => {
            if (newValue !== oldValue) {
                this._onDoNotAutoProcessChanged();
            }
        });

        this._scope.$watch('configuration.notificationsForParticipants', (newValue, oldValue) => {
            if (newValue != oldValue) {
                this._onNotificationsForParticipantsChanged();
            }
        });

        this._rootScope.$on(Constants.RootEvents.CART_CHANGED, () => {
            this._scope.configuration.readOnly = true;
            this._reloadConfiguration();

            scopeUtils.apply(this._scope);
        });
    }

    async _setupTab(tabId) {

        this._scope.configuration.readOnly = true;

        try {
            await this._orderSetupService.editOrder(tabId);
            await this._reloadConfiguration();
            this._scope.configuration.readOnly = false;
        } catch (error) {
            this._scope.configuration.readOnly = false;
            this._messageService.showErrorPopupForResponse(error);
        }
    }

    async _editSection(id) {

        if (this._scope.configuration.readOnly) {
            return null;
        }

        switch (id) {
            case 'payment-info':
                await this._setupTab(Constants.OrderSetupTabs.PAYMENT_DETAILS);
                break;
            case 'budget':
                await this._setupTab(Constants.OrderSetupTabs.BUDGET);
                break;
            case 'delivery':
                await this._setupTab(Constants.OrderSetupTabs.DELIVERY_ADDRESS);
                break;
            case 'deadline':
                await this._setupTab(Constants.OrderSetupTabs.DEADLINE);
                break;
        }

        scopeUtils.apply(this._scope);
    }

    async _onDoNotAutoProcessChanged() {

        if (this._scope.configuration.readOnly) {
            this._scope.configuration.doNotAutoProcess = this._savedCart.automaticProcess;
            return;
        }

        this._scope.configuration.readOnly = true;

        this._savedCart.automaticProcess = !this._scope.configuration.doNotAutoProcess;

        try {
            await this._cartService.setCartConfiguration(this._savedCart);
        } catch (error) {
            this._messageService.showErrorPopupForResponse(error);
        }

        this._scope.configuration.readOnly = false;
    }

    async _onNotificationsForParticipantsChanged() {

        if (this._scope.configuration.readOnly) {
            this._scope.configuration.notificationsForParticipants = this._savedCart.sendCloseNotification;
            return;
        }

        this._scope.configuration.readOnly = true;

        this._savedCart.sendCloseNotification = this._scope.configuration.notificationsForParticipants;

        try {
            await this._cartService.setCartConfiguration(this._savedCart);
        } catch (error) {
            this._messageService.showErrorPopupForResponse(error);
        }

        this._scope.configuration.readOnly = false;
    }

    static _getPaymentMethodSection(cartDetails) {
        return {
            id: 'payment-mode',
            title: 'Payment',
            lines: [
                cartDetails.paymentMethod === Constants.CartDetails.PaymentMethods.SINGLE ? (this.$translate.instant('client.order.single_payment')) : this.$translate.instant('client.order.everyone_for')
            ],
            editable: false
        };
    }

    _getOrderDeadlineSection(cart) {
        this.retailer = this._configurationService.getRetailer().retailer;

        this.retailerTimezone = this.retailer.timeZoneSettingName;

        const dealine = {
            id: 'deadline',
            title: cart.closeOn ? '' : this.$translate.instant('client.deadline'),
            highlighted: cart.closeOn,
            lines: [
                this._getDeadlineString(cart)
            ],
            line: cart.closeOn ? moment.tz(cart.closeOn, this.retailerTimezone).format('Do MMM') : this.$translate.instant('client.none'),
            editable: cart.cartStatus !== "OWNER_CHECKING_OUT" && cart.cartStatus !== "CHECKING_OUT"
        };

        this.deadlineInterval = this.$interval(() => {
            dealine.lines[0] = this._getDeadlineString(cart);
        }, 1000);

        return dealine;
    }

    intervals = {
        year: {
            singular: 'client.year',
            plural: 'client.years'
        },
        month: {
            singular: 'client.month',
            plural: 'client.months'
        },
        week: {
            singular: 'client.week',
            plural: 'client.weeks'
        },
        day: {
            singular: 'client.day',
            plural: 'client.days'
        },
        hour: {
            singular: 'client.hour',
            plural: 'client.hours'
        },
        minute: {
            singular: 'client.minute',
            plural: 'client.minutes'
        }
    };

    _getDeadlineString(cart) {
        if (!cart.closeOn) {
            return this.$translate.instant('client.none');
        }

        const localTimeDeadline = moment.tz(cart.closeOn, this.retailerTimezone);
        if (moment(localTimeDeadline).isBefore(moment())) {
            return this.$translate.instant('client.order.closed');
        }

        let result = null;
        Object.keys(this.intervals).forEach(key => {
            if (result) {
                return;
            }
            const count = localTimeDeadline.diff(moment(), key);
            if (count > 0) {
                if (count === 1) {
                    const duration = this.$translate.instant(this.intervals[key].singular);
                    result = this.$translate.instant('client.order.end_in', { count, duration });
                } else {
                    const duration = this.$translate.instant(this.intervals[key].plural);
                    result = this.$translate.instant('client.order.end_in', { count, duration });
                }
            }
        })

        if (result) {
            return result;
        } else {
            return this.$translate.instant('client.order.time_end_min');
        }

    }

    async _getDeliverySection(cartDetails) {

        switch (cartDetails.deliveryMethod) {
            case Constants.CartDetails.DeliveryMethods.PICKUP: {
                if (this._scope.retailer.retailerType === Constants.SHOPIFY_RETAILER_TYPE ||
                  this._scope.retailer.retailerType === Constants.AMAZON_RETAILER_TYPE ||
                  this._scope.retailer.retailerType.toLowerCase() === 'poc') {
                    return;
                }

                const pickupAddress = await this._configurationService.getItem('pickupAddress');
                const ret = {
                    id: 'delivery',
                    title: this.$translate.instant('client.order.pick_up_info'),
                    lines: [
                        pickupAddress
                    ],
                    editable: true
                };
                if (cartDetails.deliveryDate) {
                    ret.lines.push(' on ' + moment.utc(cartDetails.deliveryDate).local().format('dddd[,] MMMM Do [at] LT'));
                }
                return ret;
            }
            case Constants.CartDetails.DeliveryMethods.DELIVERY: {
                if (this._scope.retailer.retailerType === Constants.SHOPIFY_RETAILER_TYPE || this._scope.retailer.retailerType.toLowerCase() === 'poc') {
                    return;
                }

                const ret = {
                    id: 'delivery',
                    title: this.$translate.instant('client.order.delivery_info'),
                    lines: [
                        cartDetails.deliveryAddress.street + ' ' + (', ' + cartDetails.deliveryAddress.aptSuite || ''),
                        cartDetails.deliveryAddress.city + ', ' + cartDetails.deliveryAddress.state + ' ' + cartDetails.deliveryAddress.zip
                    ],
                    editable: true
                };

                if (cartDetails.deliveryDate) {
                    ret.lines.push(' on ' + moment.utc(cartDetails.deliveryDate).local().format('dddd[,] MMMM Do [at] LT'));
                }

                if (cartDetails.deliveryPhone) {
                    ret.lines.push(`${this.$translate.instant('client.order.contact_phone')}: (${cartDetails.deliveryPhone.substring(0, 3)}) ${cartDetails.deliveryPhone.substring(3, 6)}-${cartDetails.deliveryPhone.substring(6, 10)} ${cartDetails.deliveryPhone.substring(10, 20)}`);
                }

                return ret;
            }
            case Constants.CartDetails.DeliveryMethods.SHIPPING:
                return {};
        }
    }

    _getBudgetSection(cart) {
        return {
            id: 'budget',
            title: this.$translate.instant('client.budget'),
            lines: [ cart.orderLimit > 0 ? this._rootScope.formatAmount(cart.orderLimit) : this.$translate.instant('client.unlimited') ],
            line: cart.orderLimit > 0 ? this._rootScope.formatAmount(cart.orderLimit) : this.$translate.instant('client.unlimited'),
            editable: cart.cartStatus !== "OWNER_CHECKING_OUT" && cart.cartStatus !== "CHECKING_OUT"
        };
    }

    static _getPaymentInfoSection() {
        return {
            id: 'payment-info',
            title: this.$translate.instant('client.order.payment_info'),
            lines: [],
            editable: false
        };
    }

    async _reloadConfiguration() {

        const cart = await this._cartService.getCart();
        this._savedCart = cart;
        const cartDetails = await this._cartService.getCartDetails();

        this._scope.configuration.singlePay = cartDetails.paymentMethod === Constants.CartDetails.PaymentMethods.SINGLE;
        this._scope.configuration.notificationsForParticipants = cart.sendCloseNotification;
        this._scope.configuration.doNotAutoProcess = !cart.automaticProcess;

        const sections = [];

        if (!this._cartonomyConfig.externalStoreMode) {
            sections.push(OrderDetailsDirective._getPaymentMethodSection(cartDetails));
        }

        sections.push(this._getOrderDeadlineSection(cart));

        if (this._rootScope.retailer && !(Constants.GENERAL_MILLS_POC.some((poc) => {
            return this._rootScope.retailer.website.indexOf(poc) > -1
        }) || this._rootScope.retailer.noBudgetMode)) {
            sections.push(this._getBudgetSection(cart));
        }

        this._scope.sections = sections.filter(section => section && section && section.lines && section.lines.length);
        this._scope.configuration.readOnly = false;

        scopeUtils.apply(this._scope);
    }

    async _loadCustomCartName(){
        this._scope.cartModel.cartNameValue = this._savedCart.cartName;
        this._scope.cartModel.cartNameOldValue = this._savedCart.cartName;
        this._scope.cartModel.customCartNames = this._rootScope.retailer.customCartNames;
    }

    _updateCartName(){
        this._scope.showUpdateCartName = true;
    }

    _cancelCartNameChange(){
        this._scope.showUpdateCartName = false;
        this._scope.cartModel.cartNameValue = this._scope.cartModel.cartNameOldValue;
    }

    async _saveCartName(){
        if(this._scope.cartModel.cartNameValue && this._scope.cartModel.cartNameValue !== this._scope.cartModel.cartNameOldValue){
            // Call api to save
            await this._cartService.updateCartName(this._scope.cartModel.cartNameValue);

            // update realtime cart name for button
            communicationService.requestToParent(commandKeys.updateMyCartButtonText, {cartNameValue: this._scope.cartModel.cartNameValue});
            this._scope.cartModel.cartNameOldValue = this._scope.cartModel.cartNameValue;
        }else{
            this._scope.cartModel.cartNameValue = this._scope.cartModel.cartNameOldValue;
        }
        this._scope.showUpdateCartName = false;
    }
}

module.controller('OrderDetailsDirectiveController', OrderDetailsDirective);

module.directive('orderDetails', [ function () {
    return {
        template: require('../views/orderDetailsDirective.pug'),
        controller: 'OrderDetailsDirectiveController',
        scope: true
    };
} ]);



// WEBPACK FOOTER //
// ./src/modules/cart/directives/OrderDetailsDirective.js